import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import "./LayerSearchBar.css";

const LayerSearchbar = ({ onSearchTermChange }) => {
  /**
   * Ths function takes input from the user and uses it to filter the rendered divs
   * @param {*} e
   */
  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    onSearchTermChange(inputValue);
    console.log(inputValue);
  };
  return (
    <div className="layer-searchbar-container">
      <FontAwesomeIcon icon={faSearch} />
      <input
        type="text"
        className="layer-searchbar"
        placeholder="Search for layers..."
        onChange={handleInputChange}
      />
    </div>
  );
};

export default LayerSearchbar;
